import React from 'react'
import { IconAlertTriangle } from '@tabler/icons-react'

interface PreviewErrorStateProps {
  title: string
  message: string
  onRetry?: () => void
  secondaryAction?: { label: string; onClick: () => void }
}

export const PreviewErrorState: React.FC<PreviewErrorStateProps> = ({
  title,
  message,
  onRetry,
  secondaryAction
}) => (
  <div
    className="flex h-full flex-col items-center justify-center gap-1 p-2 text-center"
    role="alert">
    <IconAlertTriangle size={40} className="theme-icon-muted" aria-hidden="true" />
    <p className="theme-text-heading font-semibold mb-0">{title}</p>
    <p className="theme-text-subheading mb-1">{message}</p>
    <div className="flex items-center gap-50">
      {onRetry && (
        <button
          type="button"
          className="theme-border-default rounded-md border px-1 py-50"
          onClick={onRetry}>
          Try again
        </button>
      )}
      {secondaryAction && (
        <button
          type="button"
          className="theme-border-default rounded-md border px-1 py-50"
          onClick={secondaryAction.onClick}>
          {secondaryAction.label}
        </button>
      )}
    </div>
  </div>
)
